import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Hooks/AuthProvider";
import LoadingSpinner from "./LoadingSpinner";
import { useState, useEffect } from "react";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

/**
 * Protected route for customer users only
 * Customers can only access the Project Equipment page
 */
export const CustomerProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  // Initialize Firebase Functions
  useEffect(() => {
    const functions = getFunctions();
    if (process.env.NODE_ENV === "development") {
      connectFunctionsEmulator(functions, "localhost", 5001);
    }
  }, []);

  // Get user role when user is authenticated
  useEffect(() => {
    const getUserRole = async () => {
      if (!user) {
        setRoleLoading(false);
        return;
      }

      try {
        const functions = getFunctions();
        const getUserRoleFunction = httpsCallable(functions, "getUserRole");
        const response = await getUserRoleFunction();
        setUserRole(response.data.role);
      } catch (error) {
        console.error("[CustomerProtectedRoute] Error getting user role:", error);
        setUserRole(null);
      } finally {
        setRoleLoading(false);
      }
    };

    getUserRole();
  }, [user]);

  // Show loading while auth or role is loading
  if (loading || roleLoading) {
    return <LoadingSpinner />;
  }

  // If no user, redirect to customer login
  if (!user) {
    return <Navigate to="/customer-login" state={{ from: location }} replace />;
  }

  // If user is not a customer, redirect to main app login
  if (userRole !== "customer") {
    return <Navigate to="/" replace />;
  }

  // Customer user - allow access
  return children;
};

